import React from 'react';
import { PlusCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface NewInvestigationCardProps {
  onClick: () => void;
}

const NewInvestigationCard: React.FC<NewInvestigationCardProps> = ({ onClick }) => {
  const { t } = useTranslation();

  return (
    <div
      onClick={onClick}
      className="bg-white border border-gray-200 shadow-md rounded-lg p-6 flex flex-col items-center justify-center cursor-pointer hover:shadow-lg hover:bg-gray-50 transition duration-200"
    >
      <PlusCircle className="h-12 w-12 text-gray-500 mb-2 transition duration-200 group-hover:text-blue-600" />
      <h3 className="text-lg font-semibold text-gray-700 mb-1">
        {t('myResearch.newInvestigationCardTitle')}
      </h3>
      <p className="text-sm text-gray-500 text-center">
        {t('myResearch.newInvestigationCardSubtitle')}
      </p>
    </div>
  );
};

export default NewInvestigationCard;
